// import componenti
import ListaSpese from "../../components/ListaSpese";

// import hooks
import { useCollection } from "../../hooks/useCollection";
// import { useAuthContext } from "../../hooks/useAuthContext";

// import pacchetti
import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import format from "date-fns/format";
import { it } from "date-fns/locale";
import Select from "react-select";

// import styles
import "./Dashboard.css";

// Opzioni per i mesi
const opzioniMesi = [
  { value: "", label: "Tutti i mesi" },
  { value: "gennaio", label: "Gennaio" },
  { value: "febbraio", label: "Febbraio" },
  { value: "marzo", label: "Marzo" },
  { value: "aprile", label: "Aprile" },
  { value: "maggio", label: "Maggio" },
  { value: "giugno", label: "Giugno" },
  { value: "luglio", label: "Luglio" },
  { value: "agosto", label: "Agosto" },
  { value: "settembre", label: "Settembre" },
  { value: "ottobre", label: "Ottobre" },
  { value: "novembre", label: "Novembre" },
  { value: "dicembre", label: "Dicembre" },
];

// Genera automaticamente gli anni da 2022 all'anno corrente
const opzioniAnni = (() => {
  const annoIniziale = 2022;
  const annoCorrente = new Date().getFullYear();
  const anniTotali = [{ value: "", label: "Tutti gli anni" }];

  for (let anno = annoIniziale; anno <= annoCorrente; anno++) {
    anniTotali.push({
      value: anno.toString(),
      label: anno.toString(),
    });
  }

  return anniTotali;
})();

export default function Dashboard() {
  // const navigazione = useNavigate();
  // const { user } = useAuthContext();
  const { documents, error } = useCollection("spese");
  const [speseFiltrate, setSpeseFiltrate] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(opzioniMesi[0]);
  const [selectedYear, setSelectedYear] = useState(opzioniAnni[0]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [totaliPagamento, setTotaliPagamento] = useState(null);

  // Applica i filtri quando cambiano i criteri di ricerca o i documenti
  useEffect(() => {
    if (documents) {
      const uniqueUsersMap = new Map();
      documents.forEach((spesa) => {
        if (spesa.autore && spesa.autore.id && spesa.autore.displayName) {
          if (!uniqueUsersMap.has(spesa.autore.id)) {
            uniqueUsersMap.set(spesa.autore.id, {
              value: spesa.autore.id,
              label: spesa.autore.displayName,
            });
          }
        }
      });
      setUserOptions([
        { value: "", label: "Tutti gli utenti" },
        ...Array.from(uniqueUsersMap.values()),
      ]);
    }

    // Funzione per filtrare le spese in base ai criteri selezionati
    const applyFilters = () => {
      if (!documents) return;

      const filtro = documents.map((spesa) => {
        // Estrai mese e anno dalla data della spesa
        const spesaMese = format(spesa.data.toDate(), "MMMM", {
          locale: it,
        }).toLowerCase();
        const spesaAnno = format(spesa.data.toDate(), "Y", { locale: it });

        // Verifica se la spesa corrisponde ai criteri di ricerca testuale
        const matchesSearchTerm =
          searchTerm === "" ||
          spesa.nome.toLowerCase().includes(searchTerm) ||
          spesa.importo.includes(searchTerm) ||
          spesa.settore.includes(searchTerm) ||
          spesa.autore.displayName.toLowerCase().includes(searchTerm);

        // Verifica se la spesa corrisponde all'utente selezionato
        const matchesUser =
          !selectedUser ||
          selectedUser.value === "" ||
          spesa.autore.id === selectedUser.value;

        // Verifica se la spesa corrisponde al mese selezionato
        const matchesMonth =
          selectedMonth.value === "" || spesaMese === selectedMonth.value;

        // Verifica se la spesa corrisponde all'anno selezionato
        const matchesYear =
          selectedYear.value === "" || spesaAnno === selectedYear.value;

        // La spesa è visibile solo se corrisponde a tutti i criteri
        spesa.isVisible =
          matchesSearchTerm && matchesMonth && matchesYear && matchesUser;
        return spesa;
      });

      setSpeseFiltrate(filtro);

      // Calcola i totali per tipo di pagamento quando c'è un utente selezionato e un periodo
      if (
        selectedUser &&
        selectedUser.value !== "" &&
        selectedMonth.value !== "" &&
        selectedYear.value !== ""
      ) {
        const visibili = filtro.filter((spesa) => spesa.isVisible);
        const totals = visibili.reduce((acc, spesa) => {
          const key = spesa.pagamento || "Non specificato";
          const importoNum = parseFloat(spesa.importo) || 0;
          acc[key] = (acc[key] || 0) + importoNum;
          return acc;
        }, {});
        setTotaliPagamento(totals);
      } else {
        setTotaliPagamento(null);
      }
    };

    if (documents) {
      applyFilters();
    }
  }, [documents, searchTerm, selectedMonth, selectedYear, selectedUser]);

  // Gestisce il cambio del termine di ricerca
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  // Gestisce il cambio del mese selezionato
  const handleMonthChange = (option) => {
    setSelectedMonth(option);
  };

  // Gestisce il cambio dell'anno selezionato
  const handleYearChange = (option) => {
    setSelectedYear(option);
  };

  const handleUserChange = (option) => {
    setSelectedUser(option);
  };

  return (
    <div>
      <div className="title-container">
        <h2 className="page-title">Spese</h2>
      </div>
      <div>
        <div className="filters-container">
          <input
            type="text"
            onChange={handleSearchChange}
            placeholder="Cerca"
            className="search-bar"
          />
          <div className="dropdown-filters">
            <Select
              className="filter-select"
              options={opzioniMesi}
              onChange={handleMonthChange}
              value={selectedMonth}
              placeholder="Seleziona mese"
              isSearchable={false}
            />
            <Select
              className="filter-select"
              options={opzioniAnni}
              onChange={handleYearChange}
              value={selectedYear}
              placeholder="Seleziona anno"
              isSearchable={false}
            />
            <Select
              className="filter-select"
              options={userOptions}
              onChange={handleUserChange}
              value={selectedUser}
              placeholder="Seleziona utente"
              isSearchable
              isClearable
            />
          </div>
        </div>
      </div>
      {error && <p className="error">{error}</p>}

      {totaliPagamento && (
        <div className="summary-cards" style={{ marginTop: "20px" }}>
          {Object.entries(totaliPagamento).map(([pagamento, totale]) => (
            <div key={pagamento} className="summary-card">
              <h3>{pagamento}</h3>
              <p className="summary-number">
                {totale.toFixed(2)} €
              </p>
            </div>
          ))}
        </div>
      )}

      {documents && (
        <ListaSpese
          data={speseFiltrate ? speseFiltrate : documents}
          visible={!speseFiltrate}
        />
      )}
    </div>
  );
}
